import strings from "./strings";

export default strings;
